import type { ApplicationEdition } from '@atlassian/jira-shared-types';

export const NCS = 'ncs';
export const SYNCHRONY = 'synchrony';

export const PARENT_PRODUCT = 'JSM';
export const USER_ID_TYPE = 'atlassianAccount';
export const TEAM_NAME = 'jsm-nebula';

export const MONTHLY_BILLED = 'MONTHLY' as const;
export const ANNUALLY_BILLED = 'ANNUAL' as const;
export const INACTIVE = 'INACTIVE' as const;

export type BillingPeriod = typeof MONTHLY_BILLED | typeof ANNUALLY_BILLED | typeof INACTIVE;

export type ProductDetails = {
	edition: ApplicationEdition;
	billingPeriod: BillingPeriod;
	trialEndDate: Date | null;
	firstSiteActivationDate: number;
};
